import { useRef, useState } from 'react';

const DROPDOWN_CLOSE_DELAY = 180;

const useIconToggle = () => {
  const [isAdditionalLinksOpen, setIsAdditionalLinksOpen] = useState<boolean>(false);
  const closeTimerRef = useRef<number | null>(null);

  const clearCloseTimer = (): void => {
    if (closeTimerRef.current !== null) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const openAdditionalLinks = (): void => {
    clearCloseTimer();
    setIsAdditionalLinksOpen(true);
  };

  const closeDropdown = (): void => {
    setIsAdditionalLinksOpen(false);
  };

  const scheduleCloseAdditionalLinks = (): void => {
    clearCloseTimer();

    closeTimerRef.current = window.setTimeout(() => {
      setIsAdditionalLinksOpen(false);
      closeTimerRef.current = null;
    }, DROPDOWN_CLOSE_DELAY);
  };

  return {
    openAdditionalLinks,
    scheduleCloseAdditionalLinks,
    closeDropdown,
    isAdditionalLinksOpen,
  };
};

export default useIconToggle;
